export default "__VITE_ASSET__c6c20c41__"